import debug from 'debug';

const log = debug('ComponentStorage');

class ComponentStorageBase {
	/**
	 * @param {Object} options
	 * @param {string} options.componentKey the component identifier
	 */
	constructor(options) {
		this.componentKey = options.componentKey;
	}

	/**
	 * @param {string} key
	 */
	clear() {
		const components = this.components();
		delete components[this.componentKey];
		log('clear()', components);

		sessionStorage.setItem(this.sessionKey, JSON.stringify(components));
	}

	/**
	 * @returns {JSON}
	 */
	components() {
		let components = sessionStorage.getItem(this.sessionKey);
		if (components === null) {
			this.initialize();
			components = sessionStorage.getItem(this.sessionKey);
		}
		return JSON.parse(components);
	}

	/**
	 * @return {JSON} value
	 */
	getComponent() {
		const components = this.components();

		return components[this.componentKey];
	}

	/**
	 * @param {string} key
	 *
	 * @return {JSON} value
	 */
	getItem(key) {
		const component = this.getComponent();

		if (component[key] === undefined) return null;

		return component[key];
	}

	initialize() {
		let components = sessionStorage.getItem(this.sessionKey);

		if (components === null) {
			components = { initialized: true };
			components[this.componentKey] = { initialized: true };
		} else {
			components = JSON.parse(components);

			if (components[this.componentKey] === undefined) {
				components[this.componentKey] = { initialized: true };
			}
		}

		log(`${this.constructor.name !== 'ComponentStorage' ? this.constructor.name + ' ' : ''}${this.componentKey}`, components);

		sessionStorage.setItem(this.sessionKey, JSON.stringify(components));
	}

	/**
	 * @param {string} key
	 */
	removeItem(key) {
		const components = this.components();
		delete components[this.componentKey][key];
		log('removeItem()', components);

		sessionStorage.setItem(this.sessionKey, JSON.stringify(components));
	}

	/**
	 * @param {JSON} value
	 */
	setComponent(value) {
		const components = this.components();

		components[this.componentKey] = value;

		sessionStorage.setItem(this.sessionKey, JSON.stringify(components));
	}

	/**
	 * @param {string} key
	 * @param {JSON} value
	 */
	setItem(key, value) {
		const components = this.components();

		components[this.componentKey][key] = value;

		sessionStorage.setItem(this.sessionKey, JSON.stringify(components));
	}
}

export default ComponentStorageBase;
